type NumberedString = string | number;

export interface Image {
  littleThumb?: string;
  middleThumb?: string;
}

interface Images {
  littleThumb: string;
  middleThumb: string;
}

interface Article {
  id: number;
  code: string;
  title: string;
  littleThumb: string;
  middleThumb: string;
  text: string;
  desc: string;
  view: number;
  comments: number;
  event_type: string;
}

interface ArticleIn {
  desc?: string;
  id: NumberedString;
  images?: Images;
  text?: string;
  title?: string;
  url_code?: string;
  view?: NumberedString;
  comments?: NumberedString;
  event_type?: string;
}

const getNumber = (value: NumberedString = 0): number => (typeof value === 'string' ? parseInt(value, 10) : value) || 0;

const articlesMapper = ({
  desc,
  id,
  images,
  text,
  title,
  url_code,
  view,
  comments,
  event_type,
}: ArticleIn): Article => {
  const { littleThumb = '', middleThumb = '' } = images || {};
  return {
    littleThumb,
    middleThumb,
    id: getNumber(id),
    code: url_code || '',
    desc: desc || '',
    text: text || '',
    title: title || '',
    view: getNumber(view),
    comments: getNumber(comments),
    event_type: event_type || '',
  };
}

export default articlesMapper;



// WEBPACK FOOTER //
// ./src/helpers/convertArticlesFromApi.ts